import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import SignatureCanvas from "react-signature-canvas";
import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import onsiteproLogo from '../../assets/logo2 2.png';
import CheckTick from "../../assets/icons/Check-Tick.png";
import "../forms/formTitle.css";
import "../forms/themeCheckbox.css";
import "../forms/themePlaceholder.css";
import AdminTaylorImportModal, { adminIsPrimaryAdmin } from "./AdminTaylorImportModal";
import { ensureFormUuid, noopCreateSuccess } from "../../utils/formUuid";
import { buildSharePointFileName, toDdMmYyyy, addedByName } from "../../utils/formPdfHelpers";
import "./horizonTable.css";

import { canEditDeleteRecords } from "../../utils/rolePermissions";
function parseSiteRegisterDate(value) {
  if (!value) return null;
  const s = String(value).trim();
  const slash = s.split("/");
  if (slash.length === 3) {
    const [dd, mm, yyyy] = slash;
    const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const dash = s.split("-");
  if (dash.length === 3) {
    if (dash[0].length === 4) {
      const d = new Date(Number(dash[0]), Number(dash[1]) - 1, Number(dash[2]));
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const [dd, mm, yyyy] = dash;
    const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function formatSiteRegisterDate(date) {
  if (!date) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

const siteRegisterDatePickerProps = {
  dateFormat: "dd-MM-yyyy",
  className: "form-control",
  placeholderText: "dd-MM-yyyy",
  todayButton: "Today",
  calendarClassName: "site-register-theme-calendar",
  popperClassName: "site-register-datepicker-popper",
  popperPlacement: "bottom-start",
  popperProps: { strategy: "fixed" },
};

const PPM_THEME = "#8b1634";
const ppmEditLabelStyle = { fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6, display: "block" };
const ppmEditInputStyle = {
  borderRadius: 8,
  border: "1px solid #e2e8f0",
  fontSize: 14,
  padding: "8px 12px",
};

function PPMReportPage() {
  const canEditDelete = canEditDeleteRecords();
  const [records, setRecords] = useState([]);
  const [appUsers, setAppUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [uploadingKey, setUploadingKey] = useState(null);

  // Modal state
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const isAdminUser = adminIsPrimaryAdmin();
  const [showSharePointUploadModal, setShowSharePointUploadModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [sharePointUploadRecord, setSharePointUploadRecord] = useState(null);
  
  // SharePoint upload form state
  const [sharePointPhaseType, setSharePointPhaseType] = useState('phase'); // 'phase' triggers upload, 'non-phase' currently disabled
  const [sharePointPhaseNumber, setSharePointPhaseNumber] = useState('15'); // '15', '16', etc.
  const [sharePointNetwork, setSharePointNetwork] = useState('');
  const [pendingDirectUpload, setPendingDirectUpload] = useState(false);
  useEffect(() => {
    if (pendingDirectUpload && sharePointUploadRecord) {
      setPendingDirectUpload(false);
      // eslint-disable-next-line no-use-before-define
      handleSharePointUpload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingDirectUpload, sharePointUploadRecord]); // 'EPN', 'LPN', 'SPN'

  const [newRecord, setNewRecord] = useState({
    formUuid: "",
    userId: "",
    fullSiteName: "",
    address: "",
    postCode: "",
    mcqQuestionsList: [
      { header: 'Access /Safety Requirements', checkboxOptions: [], checkboxValues: {}, items: [
        { title: 'Are there any areas that have local access requirements i.e shared NG Sites', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: "Are there any areas that require LOA's / Supervision", options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Are there any requirements for working at height equipment: Mobile Towers, Podiums, MEWPS etc', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Are there any confined space that require the use of a Gas Monitor?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } }
      ]},
      { header: 'Access Control', checkboxOptions: [], checkboxValues: {}, items: [
        { title: 'Are readers working with UKPN access card (inc. PIN code if fitted) - Check with SMC to ensure events are being received', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'is ACU Firmware up-to-date', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: "Are all Push to Exits's working", options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Are all Break glasses Intact', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Have the backup Batteries been Checked', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Have the backup Batteries been rEPLACED (where required)', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Are gates fully integrated with system', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Does the Access system require repairs or improvements (if so, state at end of document)', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } }
      ]},
      { header: 'Audio PA', checkboxOptions: ['Commend','ADPRO','Heitel'], checkboxValues: { 'Commend': false, 'ADPRO': false, 'Heitel': false }, items: [
        { title: 'Does PA work locally on site - Test with SMC', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Is PA audible and clear', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Does the system require or improvements (if so, state at end of document)', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } }
      ]},
      { header: 'CCTV', checkboxOptions: ['Heitel','ADPRO'], checkboxValues: { 'Heitel': false, 'ADPRO': false }, items: [
        { title: 'Are Cameras Clean and in focus?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '' } },
        { title: 'Are PTZ cameras and telemetry functioning correctly', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Are PTZ cameras and home positions been set correctly (check against commissioning documentation)?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Has masking been applied to project local residents privacy?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Is Cause and Effect Detection working - conduct a walk test to confirm maximum detection coverage, check with SMC?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Is DVR/NVR Firmware up-to-date?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Are cameras set to correct Frames per second (check against commissioning documentation)', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Can recordings be accessed?', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } },
        { title: 'Does the CCTV system require repairs or improvements (if so, state at end of document)', options: ['YES','NO','N/A'], value: '', hasCheckbox: false, textField: { isTextBox: false, hintText: '', valueType: '', n_a: false } }
      ]}
    ],
    descriptionOfWorks: "",
    checkedBy: "",
    timeOn: "",
    timeOff: "",
    date: "",
    signature: ""
  });
  const [editSignature, setEditSignature] = useState("");
  const sigCanvasRef = useRef(null);
  const editSigCanvasRef = useRef(null);

  // Helper function to convert date format from DD/MM/YYYY to YYYY-MM-DD for HTML date input
  const convertDateForInput = (dateString) => {
    if (!dateString) return '';
    // Check if it's already in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    // Convert from DD/MM/YYYY to YYYY-MM-DD
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dateString;
  };

  // Helper function to convert date format from YYYY-MM-DD to DD/MM/YYYY for saving
  const convertDateForSave = (dateString) => {
    if (!dateString) return '';
    // Check if it's already in DD/MM/YYYY format
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }
    // Convert from YYYY-MM-DD to DD/MM/YYYY
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const [year, month, day] = dateString.split('-');
      return `${day}/${month}/${year}`;
    }
    return dateString;
  };

  // Normalize MCQ data coming from API (strings, booleans, etc.)
  const normalizeMcq = (sections) => {
    if (!Array.isArray(sections)) return [];
    return sections.map(section => {
      const checkboxValues = section.checkboxValues || {};
      const normalizedCheckboxValues = Object.fromEntries(
        Object.entries(checkboxValues).map(([k, v]) => [k, v === true || v === 'true'])
      );
      const items = Array.isArray(section.items) ? section.items.map(item => {
        const raw = item.value;
        let booleanValue = (raw === true || raw === 'true');
        let value = raw;
        if (Array.isArray(item.options) && item.options.length && typeof raw === 'string') {
          const lower = raw.toLowerCase();
          if (lower === 'true') value = 'YES';
          else if (lower === 'false') value = 'NO';
        }
        const textField = item.textField || {};
        const naFlag = (textField['n/a'] === true || textField['n/a'] === 'true');
        // Priority: item.textFieldValue > textField.valueType > textField.value
        const textFieldValue = item.textFieldValue || textField.valueType || textField.value || '';
        // A text-field with a hint and no radio options is a text box. Corrects items
        // (e.g. "Are External Bells connected or silenced") saved with isTextBox=false
        // by mistake, so they render as a text box + N/A instead of a bare checkbox.
        const hasRadioOptions = Array.isArray(item.options) && item.options.length > 0;
        const isTextBoxField = !!textField.isTextBox || (!hasRadioOptions && !!String(textField.hintText || '').trim());
        // Fix the title for "Are all Push to Exitss working" -> "Are all Push to Exits's working"
        let title = item.title || '';
        // Fix various incorrect spellings of "Exits's"
        if (title) {
          title = title.replace(/Push to Exitss\s+working/gi, "Push to Exits's working");
          title = title.replace(/Push to Exitss\b/gi, "Push to Exits's");
        }
        return {
          ...item,
          title,
          value,
          booleanValue,
          textFieldValue: textFieldValue,
          textField: {
            isTextBox: isTextBoxField,
            hintText: textField.hintText || '',
            valueType: textField.valueType || '',
            value: textField.value || '',
            na: naFlag
          }
        };
      }) : [];
      return {
        ...section,
        checkboxValues: normalizedCheckboxValues,
        items
      };
    });
  };

  const handleMcqNAChange = (sectionIdx, itemIdx, checked, isEdit = false) => {
    if (isEdit) {
      const updated = [...editRecord.mcqQuestionsList];
      const it = updated[sectionIdx].items[itemIdx];
      updated[sectionIdx].items[itemIdx] = { ...it, textField: { ...it.textField, na: !!checked } };
      setEditRecord({ ...editRecord, mcqQuestionsList: updated });
    } else {
      const updated = [...newRecord.mcqQuestionsList];
      const it = updated[sectionIdx].items[itemIdx];
      updated[sectionIdx].items[itemIdx] = { ...it, textField: { ...it.textField, na: !!checked } };
      setNewRecord({ ...newRecord, mcqQuestionsList: updated });
    }
  };

  // Signature pad handlers for Add Modal
  const clearSignature = () => {
    if (sigCanvasRef.current) {
    sigCanvasRef.current.clear();
    }
    setNewRecord(prev => ({ ...prev, signature: "" }));
  };
  const saveSignature = () => {
    if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
      // Get the full canvas and save at maximum quality
      const canvas = sigCanvasRef.current.getCanvas();
      // Use maximum quality PNG (1.0 = no compression)
      const sig = canvas.toDataURL("image/png", 1.0);
      setNewRecord(prev => ({
        ...prev,
        signature: sig
      }));
    }
  };

  // Signature pad handlers for Edit Modal
  const clearEditSignature = () => {
    if (editSigCanvasRef.current) {
    editSigCanvasRef.current.clear();
    }
    setEditSignature("");
    setEditRecord(prev => ({ ...prev, signature: "" }));
  };
  const saveEditSignature = () => {
    if (editSigCanvasRef.current && !editSigCanvasRef.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = editSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditSignature(sig);
      setEditRecord(prev => ({ ...prev, signature: sig }));
    }
  };

  useEffect(() => {
    async function fetchRecords() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + "/api/ppm-report", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.data)) {
          setRecords(data.data);
        } else {
          setRecords([]);
        }
      } catch {
        setRecords([]);
      }
    }
    async function fetchAppUsers() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + "/api/app-users", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.data)) {
          setAppUsers(data.data);
        } else {
          setAppUsers([]);
        }
      } catch {
        setAppUsers([]);
      }
    }
    fetchRecords();
    fetchAppUsers();
  }, []);

  // Search logic
  const filtered = records.filter(r => {
    const fields = [r.fullSiteName, r.address, r.descriptionOfWorks, r.checkedBy].map(val => (val || '').toLowerCase());
    const searchWords = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (searchWords.length === 0) return true;
    return searchWords.every(word => fields.some(field => field.includes(word)));
  });
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paged = filtered.slice().slice((page-1)*pageSize, page*pageSize);

  const formatDateForDisplay = (d) => {
    if (!d) return "—";
    const x = new Date(d);
    return isNaN(x.getTime()) ? d : x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };
  
  // Reset page to 1 if current page is beyond available pages
  if (filtered.length === 0 && page > 1) {
    setPage(1);
  }

  // Add Record
  const handleAdd = async () => {
    if (!newRecord.fullSiteName || !newRecord.address || !newRecord.postCode || !newRecord.descriptionOfWorks || !newRecord.checkedBy || !newRecord.date || !newRecord.timeOn || !newRecord.timeOff) {
      toast.error("All fields are required");
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const mcqForSave = (newRecord.mcqQuestionsList || []).map(sec => ({
        ...sec,
        items: (sec.items || []).map(it => {
          const tf = it.textField || {};
          const savedTF = { ...tf };
          if ('na' in savedTF) { savedTF['n/a'] = !!savedTF.na; delete savedTF.na; }
          return {
            ...it,
            value: it.booleanValue === true ? 'YES' : it.booleanValue === false ? 'NO' : it.value,
            textField: savedTF,
            textFieldValue: it.textFieldValue || '' // Preserve textFieldValue as separate field
          };
        })
      }));
      // Convert to string format similar to the original data structure
      const mcqString = mcqForSave.map(sec => {
        const header = sec.header || '';
        const checkboxOptions = sec.checkboxOptions || [];
        const checkboxValues = sec.checkboxValues || {};
        const items = sec.items.map(it => {
          const title = it.title || '';
          const options = it.options || [];
          const value = it.value || '';
          const hasCheckbox = it.hasCheckbox || false;
          const textField = it.textField || {};
          
          // Escape single quotes in text fields to prevent string breaking
          const safeTitle = title.replace(/'/g, "\\'");
          const safeHintText = (textField.hintText || '').replace(/'/g, "\\'");
          const safeValueType = (textField.valueType || '').replace(/'/g, "\\'");
          const safeTextFieldValue = (it.textFieldValue || '').replace(/'/g, "\\'");
          
          return `{title: '${safeTitle}', options: [${options.map(opt => `'${opt}'`).join(',')}], value: '${value}', hasCheckbox: ${hasCheckbox}, textField: {isTextBox: ${textField.isTextBox || false}, hintText: '${safeHintText}', valueType: '${safeValueType}', n/a: ${textField['n/a'] || false}}, textFieldValue: '${safeTextFieldValue}'}`;
        }).join(', ');
        return `{header: '${header.replace(/'/g, "\\'")}', checkboxOptions: [${checkboxOptions.map(opt => `'${opt}'`).join(',')}], checkboxValues: {${Object.entries(checkboxValues).map(([k, v]) => `'${k}': ${v}`).join(', ')}}, items: [${items}]}`;
      }).join(', ');
      
      // Get user details for saving firstName and lastName
      const user = appUsers.find(u => u._id === newRecord.userId);
      const addedByFirstName = user ? user.firstName : '';
      const addedByLastName = user ? user.lastName : '';
      
      const payload = { 
        ...newRecord, 
        formUuid: ensureFormUuid(newRecord.formUuid),
        addedByFirstName,
        addedByLastName,
        mcqQuestionsList: `[${mcqString}]` 
      };
      const res = await fetch(baseUrl + "/api/ppm-report", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        if (noopCreateSuccess(data)) {
          toast.warn(data.message || "This record already exists. No new record was added.");
          return;
        }
        setRecords([...records, data.data]);
        setShowAddModal(false);
        setNewRecord(prev => ({
          ...prev,
          formUuid: "",
          userId: "",
          fullSiteName: "",
          address: "",
          postCode: "",
          descriptionOfWorks: "",
          checkedBy: "",
          timeOn: "",
          timeOff: "",
          date: "",
          signature: ""
        }));
        toast.success("Record added!");
      } else {
        toast.error(data.message || "Failed to add");
      }
    } catch {
      toast.error("Failed to add");
    }
  };

  // Custom MCQ parser for malformed strings
  const parseCustomMcqFormat = (str) => {
    try {
      // Remove the outer brackets and split by sections
      const cleanStr = str.replace(/^\[|\]$/g, '');
      
      // Split by section headers (looking for {header: pattern)
      const sections = [];
      let currentSection = '';
      let braceCount = 0;
      let inSection = false;
      
      for (let i = 0; i < cleanStr.length; i++) {
        const char = cleanStr[i];
        if (char === '{') {
          braceCount++;
          if (cleanStr.substring(i, i + 8) === '{header:') {
            if (currentSection.trim()) {
              sections.push(currentSection.trim());
            }
            currentSection = '';
            inSection = true;
          }
        }
        
        if (inSection) {
          currentSection += char;
        }
        
        if (char === '}') {
          braceCount--;
          if (braceCount === 0 && inSection) {
            sections.push(currentSection.trim());
            currentSection = '';
            inSection = false;
          }
        }
      }
      
      // If no sections found with the above method, try a different approach
      if (sections.length === 0) {
        // Split by looking for the pattern {header: followed by content until the next {header:
        const sectionMatches = cleanStr.match(/\{header:[^}]+\}/g);
        if (sectionMatches) {
          sections.push(...sectionMatches);
        }
      }
      
      // If still no sections, try one more approach - split by major sections
      if (sections.length === 0) {
        // Look for the major section headers we know exist
        const majorHeaders = [
          'Access /Safety Requirements',
          'Access Control', 
          'Audio PA',
          'Comms',
          'CCTV'
        ];
        
        let lastIndex = 0;
        majorHeaders.forEach((header, index) => {
          const headerIndex = cleanStr.indexOf(`{header: ${header}`);
          if (headerIndex !== -1) {
            if (index > 0) {
              // Add the previous section
              const sectionContent = cleanStr.substring(lastIndex, headerIndex).trim();
              if (sectionContent) {
                sections.push(sectionContent);
              }
            }
            lastIndex = headerIndex;
          }
        });
        
        // Add the last section
        if (lastIndex < cleanStr.length) {
          const lastSection = cleanStr.substring(lastIndex).trim();
          if (lastSection) {
            sections.push(lastSection);
          }
        }
      }
      
      
      // Parse each section
      const parsedSections = sections.map(section => {
        try {
          // Extract header
          const headerMatch = section.match(/header:\s*([^,]+)/);
          const header = headerMatch ? headerMatch[1].trim().replace(/['"]/g, '') : '';
          
          // Extract checkbox options
          const checkboxOptionsMatch = section.match(/checkboxOptions:\s*\[([^\]]*)\]/);
          const checkboxOptions = checkboxOptionsMatch ? 
            checkboxOptionsMatch[1].split(',').map(opt => opt.trim().replace(/['"]/g, '')).filter(opt => opt) : [];
          
          // Extract checkbox values
          const checkboxValuesMatch = section.match(/checkboxValues:\s*\{([^}]*)\}/);
          const checkboxValues = {};
          if (checkboxValuesMatch) {
            const pairs = checkboxValuesMatch[1].split(',').map(pair => pair.trim());
            pairs.forEach(pair => {
              const [key, value] = pair.split(':').map(s => s.trim().replace(/['"]/g, ''));
              if (key && value !== undefined) {
                checkboxValues[key] = value === 'true';
              }
            });
          }
          
          // Extract items
          const itemsMatch = section.match(/items:\s*\[([^\]]*)\]/);
          const items = [];
          if (itemsMatch) {
            const itemsStr = itemsMatch[1];
            // Split items by looking for {title: pattern with proper brace counting
            let itemStart = itemsStr.indexOf('{title:');
            while (itemStart !== -1) {
              let braceCount = 0;
              let itemEnd = -1;
              
              // Find the matching closing brace by counting braces
              for (let i = itemStart; i < itemsStr.length; i++) {
                if (itemsStr[i] === '{') {
                  braceCount++;
                } else if (itemsStr[i] === '}') {
                  braceCount--;
                  if (braceCount === 0) {
                    itemEnd = i;
                    break;
                  }
                }
              }
              
              if (itemEnd === -1) break;
              
              const itemStr = itemsStr.substring(itemStart, itemEnd + 1);
              // Debug: Check if textFieldValue is in the item string
              if (itemStr.includes('textFieldValue')) {
              }
              const item = parseItem(itemStr);
              if (item) items.push(item);
              
              itemStart = itemsStr.indexOf('{title:', itemEnd + 1);
            }
          }
          
          // If no items found with the above method, try alternative approach
          if (items.length === 0) {
            // Look for title patterns with proper brace counting
            let itemStart = section.indexOf('{title:');
            while (itemStart !== -1) {
              let braceCount = 0;
              let itemEnd = -1;
              
              // Find the matching closing brace by counting braces
              for (let i = itemStart; i < section.length; i++) {
                if (section[i] === '{') {
                  braceCount++;
                } else if (section[i] === '}') {
                  braceCount--;
                  if (braceCount === 0) {
                    itemEnd = i;
                    break;
                  }
                }
              }
              
              if (itemEnd === -1) break;
              
              const itemStr = section.substring(itemStart, itemEnd + 1);
              // Debug: Check if textFieldValue is in the item string
              if (itemStr.includes('textFieldValue')) {
              }
              const item = parseItem(itemStr);
              if (item) items.push(item);
              
              itemStart = section.indexOf('{title:', itemEnd + 1);
            }
          }
          
          return {
            header,
            checkboxOptions,
            checkboxValues,
            items
          };
        } catch (error) {
          return null;
        }
      }).filter(Boolean);
      
      return parsedSections;
    } catch (error) {
      return [];
    }
  };
  
  // Parse individual item
  const parseItem = (itemStr) => {
    try {
      // Extract title - handle single-quoted strings that may contain commas, parentheses, etc.
      // First try to match a properly quoted title
      let title = '';
      let titleStart = itemStr.indexOf('title:');
      if (titleStart !== -1) {
        titleStart += 6; // Skip "title:"
        // Skip whitespace
        while (titleStart < itemStr.length && /\s/.test(itemStr[titleStart])) {
          titleStart++;
        }
        
        // Check if it starts with a quote
        if (itemStr[titleStart] === "'") {
          // Extract quoted string, handling escaped quotes
          let quoteEnd = titleStart + 1;
          while (quoteEnd < itemStr.length) {
            if (itemStr[quoteEnd] === '\\' && quoteEnd + 1 < itemStr.length) {
              quoteEnd += 2; // Skip escaped character
            } else if (itemStr[quoteEnd] === "'") {
              // Found closing quote
              title = itemStr.substring(titleStart + 1, quoteEnd);
              title = title.replace(/\\'/g, "'"); // Unescape single quotes
              break;
            } else {
              quoteEnd++;
            }
          }
        } else {
          // No quotes - extract until comma or closing brace (but be careful with nested structures)
          // Look for the pattern: title: VALUE, where VALUE might contain commas
          // We need to find where the title ends - it should be before ", options:" or ", value:" or ", hasCheckbox:"
          const titleEndPatterns = [
            /\s*,\s*options:/,
            /\s*,\s*value:/,
            /\s*,\s*hasCheckbox:/,
            /\s*,\s*textField:/,
            /\s*,\s*checkboxValue:/
          ];
          
          let titleEnd = itemStr.length;
          for (const pattern of titleEndPatterns) {
            const match = itemStr.substring(titleStart).match(pattern);
            if (match && match.index !== undefined) {
              titleEnd = Math.min(titleEnd, titleStart + match.index);
            }
          }
          
          title = itemStr.substring(titleStart, titleEnd).trim().replace(/['"]/g, '');
        }
      }
      
      // If still no title, try fallback
      if (!title) {
        const titleMatchOld = itemStr.match(/title:\s*([^,}]+)/);
        title = titleMatchOld ? titleMatchOld[1].trim().replace(/['"]/g, '') : '';
      }
      
      // Fix the title for "Are all Push to Exitss working" -> "Are all Push to Exits's working"
      if (title) {
        title = title.replace(/Push to Exitss\s+working/gi, "Push to Exits's working");
        title = title.replace(/Push to Exitss\b/gi, "Push to Exits's");
      }
      
      // Extract options
      const optionsMatch = itemStr.match(/options:\s*\[([^\]]*)\]/);
      const options = optionsMatch ? 
        optionsMatch[1].split(',').map(opt => opt.trim().replace(/['"]/g, '')).filter(opt => opt) : [];
      
      // Extract value - handle single-quoted strings
      let value = '';
      const valueMatchQuoted = itemStr.match(/value:\s*'((?:\\'|[^'])*)'/);
      if (valueMatchQuoted) {
        value = valueMatchQuoted[1].replace(/\\'/g, "'");
      } else {
        const valueMatch = itemStr.match(/value:\s*([^,}]+)/);
        value = valueMatch ? valueMatch[1].trim().replace(/['"]/g, '') : '';
      }
      
      // Extract hasCheckbox
      const hasCheckboxMatch = itemStr.match(/hasCheckbox:\s*([^,}]+)/);
      const hasCheckbox = hasCheckboxMatch ? hasCheckboxMatch[1].trim() === 'true' : false;
      
      // Extract textField
      const textFieldMatch = itemStr.match(/textField:\s*\{([^}]*)\}/);
      const textField = {};
      if (textFieldMatch) {
        const tfStr = textFieldMatch[1];
        const isTextBoxMatch = tfStr.match(/isTextBox:\s*([^,}]+)/);
        textField.isTextBox = isTextBoxMatch ? isTextBoxMatch[1].trim() === 'true' : false;
        
        // Extract hintText - handle single-quoted strings
        let hintText = '';
        const hintTextMatchQuoted = tfStr.match(/hintText:\s*'((?:\\'|[^'])*)'/);
        if (hintTextMatchQuoted) {
          hintText = hintTextMatchQuoted[1].replace(/\\'/g, "'");
        } else {
          const hintTextMatch = tfStr.match(/hintText:\s*([^,}]+)/);
          hintText = hintTextMatch ? hintTextMatch[1].trim().replace(/['"]/g, '') : '';
        }
        textField.hintText = hintText;
        
        // Extract valueType - handle single-quoted strings
        let valueType = '';
        const valueTypeMatchQuoted = tfStr.match(/valueType:\s*'((?:\\'|[^'])*)'/);
        if (valueTypeMatchQuoted) {
          valueType = valueTypeMatchQuoted[1].replace(/\\'/g, "'");
        } else {
          const valueTypeMatch = tfStr.match(/valueType:\s*([^,}]+)/);
          valueType = valueTypeMatch ? valueTypeMatch[1].trim().replace(/['"]/g, '') : '';
        }
        textField.valueType = valueType;
        
        const naMatch = tfStr.match(/n\/a:\s*([^,}]+)/);
        textField['n/a'] = naMatch ? naMatch[1].trim() === 'true' : false;
      }
      
      // Extract textFieldValue - handle single-quoted strings
      let textFieldValue = '';
      const textFieldValueMatchQuoted = itemStr.match(/textFieldValue:\s*'((?:\\'|[^'])*)'/);
      if (textFieldValueMatchQuoted) {
        textFieldValue = textFieldValueMatchQuoted[1].replace(/\\'/g, "'");
      } else {
        // Try multiple patterns to extract textFieldValue as fallback
        const patterns = [
          /textFieldValue:\s*([^,}]+?)(?=,\s*$)/,  // textFieldValue at end with comma
          /textFieldValue:\s*([^,}]+?)(?=\s*$)/,   // textFieldValue at very end
          /textFieldValue:\s*([^,}]+)/             // textFieldValue anywhere
        ];
        
        for (const pattern of patterns) {
          const match = itemStr.match(pattern);
          if (match) {
            textFieldValue = match[1].trim().replace(/['"]/g, '');
            break;
          }
        }
      }
      // Debug log for textFieldValue issue
      if (textFieldValue) {
      } else {
      }
      
      const result = {
        title,
        options,
        value,
        hasCheckbox,
        textField,
        textFieldValue
      };
      return result;
    } catch (error) {
      return null;
    }
  };

  // Edit Record
  const handleEdit = (rec) => {
    let mcq = [];
    try {
      let str = rec.mcqQuestionsList;
      if (typeof str === 'string') {
        let s = str.trim();
        try {
          mcq = JSON.parse(s);
        } catch {
          // robust conversion for non-JSON-like strings
          // 1) Quote unquoted keys (allowing / - _ ( ) in names)
          s = s.replace(/([,{]\s*)([A-Za-z0-9_\/\-\(\)]+)(\s*:)/g, '$1"$2"$3');
          // 2) Convert single-quoted strings to double-quoted safely
          s = s.replace(/'((?:\\'|[^'])*)'/g, (m, inner) => {
            const unescaped = inner.replace(/\\'/g, "'");
            const escapedDouble = unescaped.replace(/"/g, '\\"');
            return '"' + escapedDouble + '"';
          });
          // 3) Fix booleans in known places
          s = s.replace(/(\"value\"\s*:\s*)\"true\"/g, '$1true');
          s = s.replace(/(\"value\"\s*:\s*)\"false\"/g, '$1false');
          // 4) Remove trailing commas
          s = s.replace(/,\s*([}\]])/g, '$1');
          // 5) Fix the specific format issue with missing quotes around property names
          s = s.replace(/([A-Za-z0-9_\/\-\(\)]+):/g, '"$1":');
          // 6) Fix the specific issue with "n/a" property
          s = s.replace(/"n\/a":/g, '"n/a":');
          try {
            mcq = JSON.parse(s);
          } catch (parseError) {
            // If still fails, try to manually parse the structure
            try {
              mcq = parseCustomMcqFormat(str);
            } catch (customError) {
              mcq = [];
            }
          }
        }
      } else if (Array.isArray(str)) {
        mcq = str;
      }
    } catch {
      mcq = [];
    }
    // Do NOT fallback to static; use API only in edit flow
    const normalized = normalizeMcq(Array.isArray(mcq) ? mcq : []);
    // Debug: Log to verify "Are all Push to Exits's working" question is present
    const exitsQuestion = normalized
      .flatMap(s => s.items || [])
      .find(item => item.title && item.title.includes('Push to Exit'));
    if (exitsQuestion) {
    } else {
    }
    setEditRecord({ 
      ...rec, 
      formUuid: ensureFormUuid(rec?.formUuid),
      mcqQuestionsList: normalized,
      date: rec.date ? rec.date.trim() : rec.date
    });
    setShowEditModal(true);
  };

  const handleEditSave = async () => {
    if (!editRecord.fullSiteName || !editRecord.address || !editRecord.postCode || !editRecord.descriptionOfWorks || !editRecord.checkedBy || !editRecord.date || !editRecord.timeOn || !editRecord.timeOff) {
      toast.error("All fields are required");
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const mcqForSave = (editRecord.mcqQuestionsList || []).map(sec => ({
        ...sec,
        items: (sec.items || []).map(it => {
          const tf = it.textField || {};
          const savedTF = { ...tf };
          if ('na' in savedTF) { savedTF['n/a'] = !!savedTF.na; delete savedTF.na; }
          return {
            ...it,
            value: it.value || '',
            textField: savedTF,
            textFieldValue: it.textFieldValue || '' // Preserve textFieldValue as separate field
          };
        })
      }));
      
      
      // Convert to string format similar to the original data structure
      const mcqString = mcqForSave.map(sec => {
        const header = sec.header || '';
        const checkboxOptions = sec.checkboxOptions || [];
        const checkboxValues = sec.checkboxValues || {};
        const items = sec.items.map(it => {
          const title = it.title || '';
          const options = it.options || [];
          const value = it.value || '';
          const hasCheckbox = it.hasCheckbox || false;
          const textField = it.textField || {};
          return `{title: '${title.replace(/'/g, "\\'")}', options: [${options.map(opt => `'${opt}'`).join(',')}], value: '${value}', hasCheckbox: ${hasCheckbox}, textField: {isTextBox: ${textField.isTextBox || false}, hintText: '${textField.hintText || ''}', valueType: '${textField.valueType || ''}', n/a: ${textField['n/a'] || false}}, textFieldValue: '${(it.textFieldValue || '').replace(/'/g, "\\'")}'}`;
        }).join(', ');
        return `{header: '${header.replace(/'/g, "\\'")}', checkboxOptions: [${checkboxOptions.map(opt => `'${opt}'`).join(',')}], checkboxValues: {${Object.entries(checkboxValues).map(([k, v]) => `'${k}': ${v}`).join(', ')}}, items: [${items}]}`;
      }).join(', ');
      
      // Get user details for saving firstName and lastName
      const user = appUsers.find(u => u._id === editRecord.userId);
      const addedByFirstName = user ? user.firstName : '';
      const addedByLastName = user ? user.lastName : '';
      
      const payload = { 
        ...editRecord, 
        formUuid: ensureFormUuid(editRecord.formUuid),
        addedByFirstName,
        addedByLastName,
        mcqQuestionsList: `[${mcqString}]` 
      };
      
      
      const res = await fetch(baseUrl + `/api/ppm-report/${editRecord._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      
      
      if (res.ok && data.success) {
        // Update records with the API response data, not the editRecord state
        // The API returns data.data.data as the actual record, so we need to access it correctly
        const updatedRecord = data.data.data;
        if (updatedRecord) {
          setRecords(records.map(r => r._id === editRecord._id ? updatedRecord : r));
        }
        
        // Refetch all records to ensure data consistency
        try {
          const refreshRes = await fetch(baseUrl + "/api/ppm-report", {
            headers: { "Authorization": `Bearer ${token}` }
          });
          const refreshData = await refreshRes.json();
          if (refreshRes.ok && refreshData.success && Array.isArray(refreshData.data)) {
            setRecords(refreshData.data);
          }
        } catch (refreshError) {
        }
        
        setShowEditModal(false);
        toast.success("Record updated!");
      } else {
        toast.error(data.message || `Failed to update (Status: ${res.status})`);
      }
    } catch {
      toast.error("Failed to update");
    }
  };

  // SharePoint Upload Handler
  const handleSharePointUpload = async () => {
    const siteNameForUpload = (sharePointUploadRecord?.fullSiteName || '').trim();

    if (!siteNameForUpload) {
      toast.error('Site name is missing for this record.');
      return;
    }

    if (sharePointPhaseType === 'phase' && (!sharePointNetwork || sharePointNetwork.trim() === '')) {
      toast.error('Please select an area (EPN, LPN, or SPN)');
      return;
    }

    const payloadPhaseType = sharePointPhaseType === 'phase' ? 'phase' : 'non-phase';
    const payloadNetwork = sharePointPhaseType === 'phase' ? sharePointNetwork : '';
    const payloadPhaseNumber = sharePointPhaseType === 'phase' ? sharePointPhaseNumber : '';

    setShowSharePointUploadModal(false);

    await generatePDF(sharePointUploadRecord, {
      uploadOnly: true,
      phaseType: payloadPhaseType,
      phaseNumber: payloadPhaseNumber,
      network: payloadNetwork,
      siteName: siteNameForUpload,
      onSuccess: () => {
        setSharePointUploadRecord(null);
        setSharePointPhaseType('phase');
        setSharePointPhaseNumber('15');
        setSharePointNetwork('');
      },
      onError: () => {}
    });
  };

  // Delete Record
  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const res = await fetch(baseUrl + `/api/ppm-report/${deleteId}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setRecords(records.filter(r => r._id !== deleteId));
        toast.success("Deleted successfully!");
      } else {
        toast.error(data.message || "Failed to delete");
      }
    } catch {
      toast.error("Failed to delete");
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  // MCQ Questions List handlers
  const handleMcqChange = (sectionIdx, itemIdx, value, isEdit = false) => {
    if (isEdit) {
      const updatedSections = [...editRecord.mcqQuestionsList];
      const item = updatedSections[sectionIdx].items[itemIdx];
      updatedSections[sectionIdx].items[itemIdx] = {
        ...item,
        value,
        booleanValue: value === 'YES' ? true : value === 'NO' ? false : item.booleanValue
      };
      setEditRecord({ ...editRecord, mcqQuestionsList: updatedSections });
    } else {
      const updatedSections = [...newRecord.mcqQuestionsList];
      const item = updatedSections[sectionIdx].items[itemIdx];
      updatedSections[sectionIdx].items[itemIdx] = {
        ...item,
        value,
        booleanValue: value === 'YES' ? true : value === 'NO' ? false : item.booleanValue
      };
      setNewRecord({ ...newRecord, mcqQuestionsList: updatedSections });
    }
  };

  const handleMcqCheckboxChange = (sectionIdx, checkboxKey, value, isEdit = false) => {
    if (isEdit) {
      const updatedSections = [...editRecord.mcqQuestionsList];
      updatedSections[sectionIdx].checkboxValues[checkboxKey] = value;
      setEditRecord({ ...editRecord, mcqQuestionsList: updatedSections });
    } else {
      const updatedSections = [...newRecord.mcqQuestionsList];
      updatedSections[sectionIdx].checkboxValues[checkboxKey] = value;
      setNewRecord({ ...newRecord, mcqQuestionsList: updatedSections });
    }
  };

  const handleMcqTextFieldChange = (sectionIdx, itemIdx, value, isEdit = false) => {
    // Debug log for textFieldValue changes
    
    if (isEdit) {
      const updatedSections = [...editRecord.mcqQuestionsList];
      updatedSections[sectionIdx].items[itemIdx].textFieldValue = value;
      setEditRecord({ ...editRecord, mcqQuestionsList: updatedSections });
    } else {
      const updatedSections = [...newRecord.mcqQuestionsList];
      updatedSections[sectionIdx].items[itemIdx].textFieldValue = value;
      setNewRecord({ ...newRecord, mcqQuestionsList: updatedSections });
    }
  };

  // Text handler
  const handleTextChange = (field, value, isEdit = false) => {
    if (isEdit) {
      setEditRecord({ ...editRecord, [field]: value });
    } else {
      setNewRecord({ ...newRecord, [field]: value });
    }
  };

  const generatePDF = async (record, options = {}) => {
    const shouldUploadToSharePoint = options.uploadOnly === true;
    const uploadConfig = shouldUploadToSharePoint ? {
      phaseType: options.phaseType || 'non-phase',
      phaseNumber: options.phaseNumber || '',
      network: options.network || '',
      siteName: options.siteName || '',
      onSuccess: options.onSuccess,
      onError: options.onError
    } : null;
    
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    
    // Modern color scheme
    const primaryColor = [139, 22, 52]; // #8b1634
    const secondaryColor = [233, 207, 214]; // #e9cfd6
    
    // Helper function to draw modern rounded rectangle
    const drawRoundedRect = (x, y, width, height, radius, fillColor, strokeColor, hasShadow = false) => {
      if (hasShadow) {
        doc.setFillColor(0, 0, 0, 0.1);
        doc.roundedRect(x + 1, y + 1, width, height, radius, radius, 'F');
      }
      doc.setFillColor(...fillColor);
      doc.setDrawColor(...strokeColor);
      doc.setLineWidth(0.5);
      doc.roundedRect(x, y, width, height, radius, radius, 'FD');
    };
    
    // ---- HEADER SECTION ----
    const headerHeight = 30;
    drawRoundedRect(0, 0, pageWidth, headerHeight, 0, primaryColor, primaryColor);
    
    // ---- ADD HIGH-RES LOGO ----
    const addLogoToPDF = () => {
      return new Promise((resolve) => {
        const logoImg = new Image();
        logoImg.crossOrigin = 'anonymous';
        logoImg.onload = function () {
          try {
            const logoWidth = 70;
            const aspectRatio = logoImg.height / logoImg.width;
            const logoHeight = logoWidth * aspectRatio;
            const logoX = 10;
            const logoY = (headerHeight - logoHeight) / 2;
            
            const canvas = document.createElement('canvas');
            const scale = 2.5;
            canvas.width = logoImg.width * scale;
            canvas.height = logoImg.height * scale;
            const ctx = canvas.getContext('2d');
            ctx.scale(scale, scale);
            ctx.drawImage(logoImg, 0, 0);
            
            const highResDataUrl = canvas.toDataURL('image/png', 1.0);
            doc.addImage(highResDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight, '', 'NONE');
          } catch (error) {
            doc.setFillColor(255, 255, 255);
            doc.rect(10, 6, 60, 15, 'F');
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text("TAYLOR TECHNOLOGY", 15, 12);
            doc.text("SYSTEMS LIMITED", 15, 17);
          }
          resolve();
        };
        logoImg.onerror = function () {
          doc.setFillColor(255, 255, 255);
          doc.rect(10, 6, 60, 15, 'F');
          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 0);
          doc.text("TAYLOR TECHNOLOGY", 15, 12);
          doc.text("SYSTEMS LIMITED", 15, 17);
          resolve();
        };
        logoImg.src = onsiteproLogo;
      });
    };
    
    await addLogoToPDF();
    
    // ---- HEADER TEXT ----
    const titleX = 90;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text("PPM Report", titleX, 13);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("TAYLOR TECHNOLOGY SYSTEMS LIMITED", titleX, 19);
    
    let yPosition = headerHeight + 10;
    
    // ---- Section 1: Basic Information ----
    doc.setFillColor(139, 22, 52);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    
    doc.rect(10, yPosition, pageWidth - 20, 8, "F");
    doc.text("1", 14, yPosition + 5.5);
    doc.text("Basic Information", 22, yPosition + 5.5);
    yPosition += 8;
    
    autoTable(doc, {
      startY: yPosition,
      columnStyles: {
        0: { cellWidth: 45 },
        1: { cellWidth: 75 },
        2: { cellWidth: 30 },
        3: { cellWidth: 40 },
      },
      head: [
        [
          { content: "Site Name:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.fullSiteName || "", styles: { halign: "center" } },
          { content: "Date:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.date || "", styles: { halign: "center" } },
        ],
      ],
      body: [
        [
          { content: "Address:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.address || "", styles: { halign: "center" } },
          { content: "Post Code:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.postCode || "", styles: { halign: "center" } },
        ],
        [
          { content: "Description of Works:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.descriptionOfWorks || "", styles: { halign: "center" } },
          { content: "Checked By:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.checkedBy || "", styles: { halign: "center" } },
        ],
        [
          { content: "Time On:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.timeOn || "", styles: { halign: "center" } },
          { content: "Time Off:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.timeOff || "", styles: { halign: "center" } },
        ],
      ],
      styles: {
        font: "helvetica",
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        valign: "middle",
      },
      theme: "grid",
      tableWidth: pageWidth - 20,
      margin: { left: 10 },
      headStyles: {
        fillColor: [245, 245, 245],
        textColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      bodyStyles: {
        lineWidth: 0.2,
        textColor: [0, 0, 0],
      },
    });
    
    yPosition = doc.lastAutoTable.finalY + 2;
    
    // ---- Section 2: MCQ Questions List ----
    let mcqQuestionsList = [];
    try {
      if (typeof record.mcqQuestionsList === 'string') {
        try {
          mcqQuestionsList = JSON.parse(record.mcqQuestionsList);
        } catch (e) {
          mcqQuestionsList = parseCustomMcqFormat(record.mcqQuestionsList);
        }
      } else if (Array.isArray(record.mcqQuestionsList)) {
        mcqQuestionsList = record.mcqQuestionsList;
      }
    } catch (err) {
      mcqQuestionsList = [];
    }
    
    // Normalize MCQ data
    const normalizedMcq = normalizeMcq(mcqQuestionsList);
    
    if (normalizedMcq && normalizedMcq.length > 0) {
      normalizedMcq.forEach((section, sectionIdx) => {
        // Check if we need a new page
        if (yPosition + 50 > pageHeight - 30) {
          doc.addPage();
          yPosition = 20;
        }
        
        // Section Header
        doc.setFillColor(139, 22, 52);
        doc.setTextColor(255, 255, 255);
        doc.setFont("helvetica", "bold");
        doc.rect(10, yPosition, pageWidth - 20, 8, "F");
        doc.text(`${sectionIdx + 2}`, 14, yPosition + 5.5);
        doc.text(section.header || `Section ${sectionIdx + 1}`, 22, yPosition + 5.5);
        yPosition += 8;
        
        // Checklist Items Table
        if (section.items && Array.isArray(section.items) && section.items.length > 0) {
          const tableBody = section.items.map(item => {
            // If isTextBox is true, show textFieldValue in Answer column, otherwise show value
            const answerValue = item.textField?.isTextBox && item.textFieldValue 
              ? item.textFieldValue 
              : (item.value || '');
            
            return [
              { content: item.title || '', styles: { halign: "left" } },
              { content: answerValue, styles: { halign: "center" } }
            ];
          });
          
          // Calculate column widths: 85% for question, 15% for answer
          const tableWidth = pageWidth - 20;
          const questionColWidth = tableWidth * 0.85;
          const answerColWidth = tableWidth * 0.15;
          
          autoTable(doc, {
            startY: yPosition,
            columnStyles: {
              0: { cellWidth: questionColWidth, overflow: 'linebreak', halign: 'left' },
              1: { cellWidth: answerColWidth, halign: 'center' },
            },
            head: [
              [
                { content: "Question", styles: { fillColor: [240, 240, 240], fontStyle: "bold" } },
                { content: "Answer", styles: { fillColor: [240, 240, 240], fontStyle: "bold", halign: "center" } },
              ],
            ],
            body: tableBody,
            styles: {
              font: "helvetica",
              fontSize: 9,
              cellPadding: 4,
              halign: "left",
              valign: "middle",
              overflow: "linebreak",
            },
            theme: "grid",
            tableWidth: tableWidth,
            margin: { left: 10 },
            headStyles: {
              textColor: [0, 0, 0],
              fillColor: [245, 245, 245],
              lineWidth: 0.2,
            },
            bodyStyles: {
              lineWidth: 0.2,
            },
          });
          
          yPosition = doc.lastAutoTable.finalY + 2;
        }
        
        // Show checkbox options table if checkboxOptions exist
        if (section.checkboxOptions && section.checkboxOptions.length > 0 && section.checkboxValues) {
          // Check if we need a new page
          if (yPosition + 40 > pageHeight - 30) {
            doc.addPage();
            yPosition = 20;
          }
          
          const checkboxTableBody = section.checkboxOptions.map(option => [
            { content: option || '', styles: { halign: "left" } },
            { content: '', styles: { halign: "center" } } // Empty content, will be drawn as image
          ]);
          
          // Calculate column widths: 85% for checkbox options, 15% for selected
          const tableWidth = pageWidth - 20;
          const checkboxColWidth = tableWidth * 0.85;
          const selectedColWidth = tableWidth * 0.15;
          
          autoTable(doc, {
            startY: yPosition,
            columnStyles: {
              0: { cellWidth: checkboxColWidth, overflow: 'linebreak', halign: 'left' },
              1: { cellWidth: selectedColWidth, halign: 'center' },
            },
            head: [
              [
                { content: "Checkbox Options", styles: { fillColor: [240, 240, 240], fontStyle: "bold" } },
                { content: "Selected", styles: { fillColor: [240, 240, 240], fontStyle: "bold", halign: "center" } },
              ],
            ],
            body: checkboxTableBody,
            didDrawCell: (data) => {
              if (data.section === 'body' && data.column.index === 1) {
                const option = section.checkboxOptions[data.row.index];
                if (option && section.checkboxValues && (section.checkboxValues[option] === true || section.checkboxValues[option] === 'true')) {
                  const cell = data.cell;
                  const centerX = cell.x + cell.width / 2;
                  const centerY = cell.y + cell.height / 2;
                  doc.addImage(CheckTick, "PNG", centerX - 2, centerY - 2, 4, 4);
                }
              }
            },
            styles: {
              font: "helvetica",
              fontSize: 9,
              cellPadding: 4,
              halign: "left",
              valign: "middle",
              overflow: "linebreak",
            },
            theme: "grid",
            tableWidth: tableWidth,
            margin: { left: 10 },
            headStyles: {
              textColor: [0, 0, 0],
              fillColor: [245, 245, 245],
              lineWidth: 0.2,
            },
            bodyStyles: {
              lineWidth: 0.2,
            },
          });
          
          yPosition = doc.lastAutoTable.finalY + 2;
        }
      });
    }
    
    // ---- Section 6: Signatories ----
    if (yPosition + 60 > pageHeight - 30) {
      doc.addPage();
      yPosition = 20;
    }
    
    doc.setFillColor(139, 22, 52);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.rect(10, yPosition, pageWidth - 20, 10, "F");
    doc.text("Section 6 : Signatories", 15, yPosition + 7);
    yPosition += 18;
    
    // Signature box - larger size for better visibility and quality
    const boxWidth = 100;
    const boxHeight = 50;
    const boxX = 10;
    const boxY = yPosition;
    doc.setDrawColor(200, 200, 200);
    doc.setFillColor(248, 248, 248);
    doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3, "FD");
    
    // Label
    doc.setTextColor(139, 22, 52);
    doc.setFontSize(10);
    doc.text("Signature", boxX + 5, boxY + 8);
    
    // Signature image - High quality rendering with upscaling
    if (record.signature) {
      try {
        let sigSrc = record.signature;
        if (!sigSrc.startsWith('data:image')) {
          sigSrc = 'data:image/png;base64,' + sigSrc;
        }
        
        // Load image to get actual dimensions
        const sigImg = new Image();
        sigImg.crossOrigin = 'anonymous';
        await new Promise((resolve) => {
          sigImg.onload = () => {
            try {
              // Calculate available space within the box (with padding)
              const paddingX = 5;
              const paddingY = 3;
              const labelHeight = 10; // Space for label
              const availableWidth = boxWidth - (paddingX * 2); // 90mm (100 - 10)
              const availableHeight = boxHeight - labelHeight - paddingY; // 37mm (50 - 10 - 3)
              
              // Use smaller fixed size for signature (compact display)
              const maxWidth = 60; // Smaller size as requested
              const maxHeight = 25; // Smaller height
              
              // Calculate dimensions to fit the smaller size while preserving aspect ratio
              const imgAspectRatio = sigImg.width / sigImg.height;
              
              let imgWidth = maxWidth;
              let imgHeight = maxWidth / imgAspectRatio;
              
              // If height exceeds max, adjust width
              if (imgHeight > maxHeight) {
                imgHeight = maxHeight;
                imgWidth = maxHeight * imgAspectRatio;
              }
              
              // Ensure it doesn't exceed available space
              if (imgWidth > availableWidth) {
                imgWidth = availableWidth;
                imgHeight = availableWidth / imgAspectRatio;
              }
              if (imgHeight > availableHeight) {
                imgHeight = availableHeight;
                imgWidth = availableHeight * imgAspectRatio;
              }
              
              // Center the signature horizontally and vertically within the box
              const imgX = boxX + paddingX + (availableWidth - imgWidth) / 2;
              const imgY = boxY + labelHeight + (availableHeight - imgHeight) / 2; // Vertically centered
              
              // Create high-resolution canvas by scaling up the image
              // This approach scales UP before adding to PDF for better quality
              // Use higher scale factor for better quality (4x for very crisp rendering)
              const scale = 4;
              
              // Convert PDF dimensions (mm) to pixels for canvas
              // jsPDF uses 72 DPI, so 1 mm = 72/25.4 pixels ≈ 2.83 pixels
              const mmToPixels = 72 / 25.4;
              const canvasWidth = Math.round(imgWidth * mmToPixels * scale);
              const canvasHeight = Math.round(imgHeight * mmToPixels * scale);
              
              // Create high-resolution canvas
              const canvas = document.createElement('canvas');
              canvas.width = canvasWidth;
              canvas.height = canvasHeight;
              
              const ctx = canvas.getContext('2d');
              
              // Set high-quality rendering options for crisp signatures
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';
              
              // Clear canvas with white background
              ctx.fillStyle = '#FFFFFF';
              ctx.fillRect(0, 0, canvas.width, canvas.height);
              
              // Scale the image up using high-quality rendering
              // This approach scales up the original image to the larger canvas size
              ctx.drawImage(
                sigImg, 
                0, 0, sigImg.width, sigImg.height,  // Source rectangle (original size)
                0, 0, canvas.width, canvas.height   // Destination rectangle (scaled up)
              );
              
              // Convert to high-res data URL with maximum quality (1.0 = no compression loss)
              const highResDataUrl = canvas.toDataURL('image/png', 1.0);
              
              // Add to PDF with no compression ('NONE') to preserve quality
              doc.addImage(highResDataUrl, 'PNG', imgX, imgY, imgWidth, imgHeight, '', 'NONE');
            } catch (err) {
              console.error('Error adding signature to PDF:', err);
              // Fallback: try direct addition without canvas processing
              try {
                const fallbackMaxWidth = 60;
                const fallbackMaxHeight = 25;
                const fallbackPaddingX = 5;
                const fallbackLabelHeight = 10;
                const fallbackAspectRatio = sigImg.width / sigImg.height;
                let fallbackWidth = fallbackMaxWidth;
                let fallbackHeight = fallbackMaxWidth / fallbackAspectRatio;
                if (fallbackHeight > fallbackMaxHeight) {
                  fallbackHeight = fallbackMaxHeight;
                  fallbackWidth = fallbackMaxHeight * fallbackAspectRatio;
                }
                const fallbackX = boxX + fallbackPaddingX + (boxWidth - fallbackPaddingX * 2 - fallbackWidth) / 2;
                const fallbackY = boxY + fallbackLabelHeight + (boxHeight - fallbackLabelHeight - 3 - fallbackHeight) / 2;
                doc.addImage(sigSrc, 'PNG', fallbackX, fallbackY, fallbackWidth, fallbackHeight, '', 'NONE');
              } catch (fallbackErr) {
                console.error('Fallback signature addition also failed:', fallbackErr);
              }
            }
            resolve();
          };
          sigImg.onerror = () => {
            console.error('Error loading signature image');
            resolve();
          };
          sigImg.src = sigSrc;
        });
      } catch (err) {
        console.error('Signature processing error:', err);
      }
    }
    
    yPosition += boxHeight + 10;
    
    // ---- Footer Section ----
    const footerY = pageHeight - 25;
    drawRoundedRect(0, footerY, pageWidth, 25, 0, [248, 249, 250], [200, 200, 200]);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(
      `Generated on: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`,
      20,
      footerY + 8
    );
    doc.text("Page 1 of 1", pageWidth - 30, footerY + 15);
    
    // Build filename and either save or upload
    const safeName = String(record.fullSiteName || 'PPMReport').replace(/[\\/:"*?<>|]+/g, '-');
    const safeDate = String(record.date || 'Report').replace(/[\\/:"*?<>|]+/g, '-');
    
    let fileName;
    if (shouldUploadToSharePoint && uploadConfig) {
      fileName = buildSharePointFileName([
        addedByName(record),
        uploadConfig.siteName,
        toDdMmYyyy(record.date),
      ]);
    } else {
      // For regular download, use full format with prefix and date
      fileName = `PPM_${safeName}_${safeDate}.pdf`;
    }
    
    if (shouldUploadToSharePoint && uploadConfig) {
      try {
        const key = `${record._id || ''}|${record.fullSiteName || ''}|${record.date || ''}`;
        setUploadingKey(key);
        const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
        const dataUri = doc.output('datauristring');
        
        // Prepare SharePoint upload parameters
        const uploadParams = {
          fileName,
          fileBase64: dataUri,
          phaseType: uploadConfig.phaseType,
          phaseNumber: uploadConfig.phaseNumber,
          network: uploadConfig.network,
          siteName: uploadConfig.siteName, uploadContext: "reactive-ukpn-tablets", uploadSubFolder: "UKPN PPM Report"
        };
        
        const res = await fetch(`${apiUrl}/api/sharepoint/upload`, {
          method: 'POST',
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
          body: JSON.stringify(uploadParams)
        });
        if (res.status !== 204 && !res.ok) {
          let msg = 'SharePoint upload failed';
          try {
            const out = await res.json();
            msg = out?.message || msg;
          } catch (_) {}
          throw new Error(msg);
        }
        toast.success("PDF uploaded to SharePoint successfully!");
        if (uploadConfig.onSuccess) {
          uploadConfig.onSuccess();
        }
      } catch (err) {
        toast.error(err?.message || "SharePoint upload failed");
        if (uploadConfig.onError) {
          uploadConfig.onError(err);
        }
      } finally {
        setUploadingKey(null);
      }
    } else {
      doc.save(fileName);
      toast.success("Professional PPM Report PDF generated successfully!");
    }
  };

  return (
    <>
      <div style={{
        background: '#ffffff',
        borderRadius: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        padding: '24px',
        marginBottom: '24px'
      }}>
        {/* Header Section */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a202c',
            margin: 0
          }}>PPM Report</h2>
          
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            {isAdminUser && (
              <button
                type="button"
                onClick={() => setShowImportModal(true)}
                style={{
                  background: "#8b1634",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px 14px",
                  fontWeight: "600",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Import File
              </button>
            )}
          <div style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
          }}>
            <i className="fa fa-search" style={{
              position: 'absolute',
              left: '12px',
              color: '#8b1634',
              fontSize: '14px'
            }}></i>
            <input 
              type="text" 
              placeholder="Type to Search" 
              value={search} 
              onChange={e=>{ setSearch(e.target.value); setPage(1); }}
              style={{
                padding: '10px 12px 10px 36px',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                fontSize: '14px',
                outline: 'none',
                width: '250px',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#8b1634'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>
          </div>
        </div>

        {/* Table Container */}
        <div style={{
          overflowX: 'auto',
          borderRadius: '12px',
          border: '1px solid #e2e8f0'
        }}>
        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 0.8fr 0.8fr 1fr 0.8fr 1fr 1fr 1fr 1.2fr',
          background: '#f7fafc',
          padding: '12px 16px',
          borderBottom: '1px solid #e2e8f0',
          gap: '16px',
          alignItems: 'center'
        }}>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Site Name</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Address</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Post Code</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Description of Works</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Checked By</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Added By</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Updated Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Actions</div>
        </div>

          {/* Table Body */}
          <div>
            {paged.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '40px',
                color: '#718096',
                fontSize: '16px'
              }}>No records found.</div>
            ) : paged.map((r, idx) => {
                // First check if firstName and lastName are saved in the record
                // If not, try to find user from appUsers array
                let userName = '-';
                if (r.addedByFirstName && r.addedByLastName) {
                  userName = `${r.addedByFirstName} ${r.addedByLastName}`;
                } else {
                  const user = appUsers.find(u => u._id === r.userId);
                  userName = user ? `${user.firstName} ${user.lastName}` : (r.userId || '-');
                }
              return (
                  <div 
                    key={r._id || idx}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 0.8fr 0.8fr 1fr 0.8fr 1fr 1fr 1fr 1.2fr',
                      padding: '16px',
                      borderBottom: '1px solid #f1f5f9',
                      gap: '16px',
                      alignItems: 'center',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    <div style={{color: '#2d3748', fontSize: '14px'}}>{r.fullSiteName || '—'}</div>
                    <div style={{color: '#2d3748', fontSize: '14px'}}>{r.address || '—'}</div>
                    <div style={{color: '#2d3748', fontSize: '14px'}}>{r.postCode || '—'}</div>
                    <div style={{color: '#2d3748', fontSize: '14px'}}>{r.descriptionOfWorks || '—'}</div>
                    <div style={{color: '#2d3748', fontSize: '14px'}}>{r.checkedBy || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{r.date || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{userName || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatDateForDisplay(r.updatedAt || r.createdAt)}</div>
                    <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                  {canEditDelete && (
                    <button 
                      onClick={()=>handleEdit(r)}
                      title="Edit"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <i className="fa fa-edit" style={{color:'#22c55e', fontSize: '16px'}}></i>
                    </button>
                  )}
                  <button 
                    onClick={()=>generatePDF(r)}
                    title="Generate PDF"
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '6px',
                      borderRadius: '6px',
                      transition: 'background-color 0.2s',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    <i className="fa fa-file-pdf-o" style={{color:'#dc2626', fontSize: '16px'}}></i>
                  </button>
                  {(() => { 
                    const k = `${r._id || ''}|${r.fullSiteName || ''}|${r.date || ''}`; 
                    const busy = uploadingKey === k; 
                    return (
                      <button 
                        onClick={()=>{
                          if (!busy) {
                            setSharePointUploadRecord(r);
                            setSharePointPhaseType('phase');
                            setSharePointPhaseNumber('15');
                            setSharePointNetwork('');
                            setSharePointPhaseType("non-phase"); setPendingDirectUpload(true);
                          }
                        }}
                        disabled={busy}
                        title={busy ? "Uploading..." : "Upload to SharePoint"}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: busy ? 'not-allowed' : 'pointer',
                          padding: '6px',
                          borderRadius: '6px',
                          transition: 'background-color 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: busy ? 0.6 : 1
                        }}
                        onMouseEnter={(e) => !busy && (e.currentTarget.style.backgroundColor = '#f0fdf4')}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <i className={busy ? "fa fa-spinner fa-spin" : "fa fa-upload"} style={{color:'#22c55e', fontSize: '16px'}}></i>
                      </button>
                    ); 
                  })()}
                  {canEditDelete && (
                    <button 
                      onClick={()=>handleDelete(r._id)}
                      title="Delete"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <i className="fa fa-trash" style={{color:'#e53e3e', fontSize: '16px'}}></i>
                    </button>
                  )}
                </div>
              </div>
                );
            })}
          </div>
        </div>

        {/* Pagination */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginTop: '18px',
          gap: '12px'
        }}>
          <button 
            className="horizon-table-btn" 
            disabled={page===1 || filtered.length === 0} 
            onClick={()=>setPage(page-1)}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              background: (page===1 || filtered.length === 0) ? '#f7fafc' : '#ffffff',
              color: (page===1 || filtered.length === 0) ? '#a0aec0' : '#8b1634',
              cursor: (page===1 || filtered.length === 0) ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >Prev</button>
          <span style={{
            fontWeight: '700',
            color: '#8b1634',
            fontSize: '16px'
          }}>{page} / {totalPages}</span>
          <button 
            className="horizon-table-btn" 
            disabled={page===totalPages || filtered.length === 0} 
            onClick={()=>setPage(page+1)}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              background: (page===totalPages || filtered.length === 0) ? '#f7fafc' : '#ffffff',
              color: (page===totalPages || filtered.length === 0) ? '#a0aec0' : '#8b1634',
              cursor: (page===totalPages || filtered.length === 0) ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >Next</button>
        </div>
      </div>

      {/* Add Modal */}
      {showAddModal && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={{maxWidth:'1200px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Add PPM Report</h5>
                <button type="button" className="btn-close" onClick={()=>setShowAddModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="mb-2 col-md-6">
                    <label>User ID</label>
                    <input type="text" className="form-control" value={newRecord.userId} onChange={e=>handleTextChange("userId", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Full Site Name</label>
                    <input type="text" className="form-control" value={newRecord.fullSiteName} onChange={e=>handleTextChange("fullSiteName", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Address</label>
                    <input type="text" className="form-control" value={newRecord.address} onChange={e=>handleTextChange("address", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Post Code</label>
                    <input type="text" className="form-control" value={newRecord.postCode} onChange={e=>handleTextChange("postCode", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Date</label>
                    <input type="date" className="form-control" value={newRecord.date} onChange={e=>handleTextChange("date", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Checked By</label>
                    <input type="text" className="form-control" value={newRecord.checkedBy} onChange={e=>handleTextChange("checkedBy", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Time On</label>
                    <input type="time" className="form-control" value={newRecord.timeOn} onChange={e=>handleTextChange("timeOn", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Time Off</label>
                    <input type="time" className="form-control" value={newRecord.timeOff} onChange={e=>handleTextChange("timeOff", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label>Description of Works</label>
                    <textarea className="form-control" rows="3" value={newRecord.descriptionOfWorks} onChange={e=>handleTextChange("descriptionOfWorks", e.target.value)} />
                  </div>
                  <div className="mb-2 col-md-6">
                    <label className="form-label fw-semibold text-secondary">Signature</label>
                    <div style={{
                      width: '100%',
                      border: '2px solid #8b1634',
                      borderRadius: '18px',
                      background: '#e9cfd6',
                      padding: '0.5rem',
                      textAlign: 'left',
                      position: 'relative',
                      minHeight: '120px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        width: '100%',
                        height: '100px',
                        position: 'relative',
                        display: 'block'
                      }}>
                        <SignatureCanvas
                          ref={sigCanvasRef}
                          penColor="#8b1634"
                          backgroundColor="white"
                          clearOnResize={false}
                          velocityFilterWeight={0.7}
                          minWidth={2}
                          maxWidth={4}
                          dotSize={2.5}
                          throttle={16}
                          canvasProps={{
                            width: 2400,
                            height: 600,
                            style: {
                              width: '100%',
                              height: '80px',
                              border: 'none',
                              borderRadius: '12px',
                              background: 'white',
                              display: 'block',
                              touchAction: 'none',
                              cursor: 'crosshair',
                              position: 'relative'
                            }
                          }}
                          onEnd={saveSignature}
                        />
                      </div>
                      <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '8px'
                      }}>
                        <span style={{
                          fontSize: '12px',
                          color: '#8b1634',
                          fontStyle: 'italic'
                        }}>
                          Draw your signature above
                        </span>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm rounded-pill px-3"
                          style={{
                            background: 'transparent',
                            color: '#8b1634',
                            borderColor: '#8b1634'
                          }}
                          onClick={clearSignature}>
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* MCQ Sections */}
                  <div className="mb-2 col-md-12">
                    <label className="fw-bold" style={{color:'#8b1634'}}>MCQ Questions</label>
                    {Array.isArray(newRecord.mcqQuestionsList) && newRecord.mcqQuestionsList.map((section, sidx) => (
                      <div key={sidx} style={{border:'1px solid #eee', borderRadius:8, padding:12, marginTop:8}}>
                        <div className="fw-bold" style={{marginBottom:8}}>{section.header}</div>
                        {Array.isArray(section.checkboxOptions) && section.checkboxOptions.length > 0 && (
                          <div className="mb-2" style={{display:'flex', flexWrap:'wrap', gap:16}}>
                            {section.checkboxOptions.map(opt => (
                              <label key={opt} style={{display:'flex', alignItems:'center', gap:6}}>
                                <input type="checkbox" checked={!!section.checkboxValues?.[opt]} onChange={e=>handleMcqCheckboxChange(sidx, opt, e.target.checked)} /> {opt}
                              </label>
                            ))}
                          </div>
                        )}
                        {Array.isArray(section.items) && section.items.map((item, iidx) => (
                          <div key={iidx} className="mb-2" style={{paddingLeft:8}}>
                            <div className="fw-medium" style={{marginBottom:6}}>{item.title}</div>
                            <div style={{display:'flex', flexWrap:'wrap', gap:12, alignItems:'center'}}>
                              {Array.isArray(item.options) && item.options.map(opt => (
                                <label key={opt} style={{display:'flex', alignItems:'center', gap:6}}>
                                  <input type="radio" name={`add-${sidx}-${iidx}`} checked={item.value === opt} onChange={()=>handleMcqChange(sidx, iidx, opt)} /> {opt}
                                </label>
                              ))}
                              {item.hasCheckbox && !item.textField?.isTextBox && (
                                <input type="checkbox" checked={!!item.booleanValue} onChange={e=>handleMcqChange(sidx, iidx, e.target.checked ? 'YES' : 'NO')} />
                              )}
                              {item.textField?.isTextBox && (
                                <div style={{display:'flex', alignItems:'center', gap:12}}>
                                  <input 
                                    type="text" 
                                    className="form-control" 
                                    style={{
                                      maxWidth: 320,
                                      fontSize: '16px',
                                      fontFamily: 'system-ui, -apple-system, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                                      lineHeight: '1.5',
                                      padding: '8px 12px'
                                    }}
                                    placeholder={item.textField?.hintText || ''} 
                                    value={item.textFieldValue || item.textField?.valueType || item.textField?.value || ''} 
                                    onChange={e=>handleMcqTextFieldChange(sidx, iidx, e.target.value)} 
                                    disabled={!!item.textField?.na}
                                  />
                                  <label style={{display:'flex', alignItems:'center', gap:6}}>
                                    <input type="checkbox" checked={!!item.textField?.na} onChange={e=>handleMcqNAChange(sidx, iidx, e.target.checked)} /> N/A
                                  </label>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>

                 
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowAddModal(false)}>Cancel</button>
                <button type="button" className="btn" style={{background:'#8b1634', color:'#fff', fontWeight:600}} onClick={handleAdd}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && editRecord && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.45)" }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={{ maxWidth: "1100px", margin: "0 auto", border: "none", borderRadius: 14, overflow: "hidden", boxShadow: "0 12px 40px rgba(0,0,0,0.18)" }}>
              <div className="modal-header" style={{ borderBottom: "none", padding: "16px 20px", background: `linear-gradient(135deg, ${PPM_THEME} 0%, #a01a3f 100%)` }}>
                <h5 className="modal-title" style={{ color: "#fff", fontWeight: 600, fontSize: 18, margin: 0 }}>Edit PPM Report</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowEditModal(false)} />
              </div>
              <div className="modal-body" style={{ padding: "20px", background: "#fff", maxHeight: "75vh", overflowY: "auto" }}>
                <div className="row g-3">
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Full Site Name</label>
                    <input type="text" className="form-control" style={ppmEditInputStyle} value={editRecord.fullSiteName} onChange={(e) => handleTextChange("fullSiteName", e.target.value, true)} />
                  </div>
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Address</label>
                    <input type="text" className="form-control" style={ppmEditInputStyle} value={editRecord.address} onChange={(e) => handleTextChange("address", e.target.value, true)} />
                  </div>
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Post Code</label>
                    <input
                      type="text"
                      className="form-control"
                      style={ppmEditInputStyle}
                      value={editRecord.postCode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        handleTextChange("postCode", value, true);
                      }}
                      pattern="[0-9]*"
                      inputMode="numeric"
                    />
                  </div>
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Date</label>
                    <div className="site-register-datepicker-wrap">
                      <DatePicker
                        {...siteRegisterDatePickerProps}
                        selected={parseSiteRegisterDate(editRecord.date)}
                        onChange={(d) => handleTextChange("date", formatSiteRegisterDate(d), true)}
                      />
                    </div>
                  </div>
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Checked By</label>
                    <input type="text" className="form-control" style={ppmEditInputStyle} value={editRecord.checkedBy} onChange={(e) => handleTextChange("checkedBy", e.target.value, true)} />
                  </div>
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Time On</label>
                    <input type="time" className="form-control" style={ppmEditInputStyle} value={editRecord.timeOn} onChange={(e) => handleTextChange("timeOn", e.target.value, true)} />
                  </div>
                  <div className="mb-2 col-4">
                    <label style={ppmEditLabelStyle}>Time Off</label>
                    <input type="time" className="form-control" style={ppmEditInputStyle} value={editRecord.timeOff} onChange={(e) => handleTextChange("timeOff", e.target.value, true)} />
                  </div>
                  <div className="mb-2 col-md-4">
                    <label style={ppmEditLabelStyle}>Description of Works</label>
                    <textarea className="form-control" style={ppmEditInputStyle} rows="3" value={editRecord.descriptionOfWorks} onChange={(e) => handleTextChange("descriptionOfWorks", e.target.value, true)} />
                  </div>
                  <div className="mb-2 col-md-4">
                    <label style={ppmEditLabelStyle}>Signature</label>
                    <div style={{
                      width: "100%",
                      border: `2px solid ${PPM_THEME}`,
                      borderRadius: 12,
                      background: "#f8f4f5",
                      padding: "12px",
                      textAlign: "center",
                      minHeight: 120,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                      {editRecord.signature ? (
                        <img 
                          src={editRecord.signature.startsWith('data:image') 
                            ? editRecord.signature 
                            : `data:image/png;base64,${editRecord.signature}`}
                          alt="Signature" 
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100px',
                            objectFit: 'contain',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '4px',
                            backgroundColor: 'white'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ) : (
                        <span style={{ color: "#9ca3af", fontSize: 14 }}>No signature</span>
                      )}
                    </div>
                  </div>
                  {/* MCQ Sections - Edit */}
                  <div className="mb-2 col-md-12">
                    <label style={{ ...ppmEditLabelStyle, color: PPM_THEME, fontSize: 14, marginBottom: 10 }}>MCQ Questions</label>
                    {Array.isArray(editRecord.mcqQuestionsList) && editRecord.mcqQuestionsList.map((section, sidx) => (
                      <div key={sidx} style={{ border: "1px solid #e8e8e8", borderRadius: 10, overflow: "hidden", marginBottom: 12 }}>
                        <div style={{ padding: "10px 14px", background: "#f8f4f5", borderBottom: "1px solid #e8e8e8", fontWeight: 600, fontSize: 14, color: PPM_THEME }}>{section.header}</div>
                        <div style={{ padding: "12px 14px" }}>
                        {Array.isArray(section.checkboxOptions) && section.checkboxOptions.length > 0 && (
                          <div className="mb-2" style={{display:'flex', flexWrap:'wrap', gap:16}}>
                            {section.checkboxOptions.map(opt => (
                              <label key={opt} style={{display:'flex', alignItems:'center', gap:6}}>
                                <input type="checkbox" className="form-check-input theme-checkbox" checked={!!section.checkboxValues?.[opt]} onChange={e=>handleMcqCheckboxChange(sidx, opt, e.target.checked, true)} /> {opt}
                              </label>
                            ))}
                          </div>
                        )}
                        {Array.isArray(section.items) && section.items.map((item, iidx) => (
                          <div key={iidx} className="mb-2" style={{paddingLeft:8}}>
                            <div className="fw-medium" style={{marginBottom:6}}>{item.title}</div>
                            <div style={{display:'flex', flexWrap:'wrap', gap:12, alignItems:'center'}}>
                              {Array.isArray(item.options) && item.options.map(opt => (
                                <label key={opt} style={{display:'flex', alignItems:'center', gap:6}}>
                                  <input type="radio" className="form-check-input theme-checkbox" name={`edit-${sidx}-${iidx}`} checked={item.value === opt} onChange={()=>handleMcqChange(sidx, iidx, opt, true)} /> {opt}
                                </label>
                              ))}
                              {item.hasCheckbox && !item.textField?.isTextBox && (
                                <input type="checkbox" className="form-check-input theme-checkbox" checked={!!item.booleanValue} onChange={e=>handleMcqChange(sidx, iidx, e.target.checked ? 'YES' : 'NO', true)} />
                              )}
                              {item.textField?.isTextBox && (
                                <div style={{display:'flex', alignItems:'center', gap:12}}>
                                  <input 
                                    type="text" 
                                    className="form-control" 
                                    style={{
                                      maxWidth: 320,
                                      fontSize: '16px',
                                      fontFamily: 'system-ui, -apple-system, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                                      lineHeight: '1.5',
                                      padding: '8px 12px'
                                    }}
                                    placeholder={item.textField?.hintText || ''} 
                                    value={item.textFieldValue || item.textField?.valueType || item.textField?.value || ''} 
                                    onChange={e=>handleMcqTextFieldChange(sidx, iidx, e.target.value, true)} 
                                    disabled={!!item.textField?.na}
                                  />
                                  <label style={{display:'flex', alignItems:'center', gap:6}}>
                                    <input type="checkbox" className="form-check-input theme-checkbox" checked={!!item.textField?.na} onChange={e=>handleMcqNAChange(sidx, iidx, e.target.checked, true)} /> N/A
                                  </label>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                        </div>
                      </div>
                    ))}
                  </div>

                 
                </div>
              </div>
              <div className="modal-footer" style={{ borderTop: "1px solid #eee", padding: "14px 20px", background: "#fafafa", gap: 10 }}>
                <button type="button" className="btn" style={{ background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 8, padding: "8px 20px", fontWeight: 600, minWidth: 96 }} onClick={() => setShowEditModal(false)}>Cancel</button>
                <button type="button" className="btn" style={{ background: PPM_THEME, color: "#fff", fontWeight: 600, borderRadius: 8, padding: "8px 24px", border: "none" }} onClick={handleEditSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SharePoint Upload Modal */}
      {showSharePointUploadModal && sharePointUploadRecord && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'600px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Upload to SharePoint</h5>
                <button type="button" className="btn-close" onClick={()=>{
                  setShowSharePointUploadModal(false);
                  setSharePointUploadRecord(null);
                  setSharePointPhaseType('phase');
                  setSharePointPhaseNumber('15');
                  setSharePointNetwork('');
                }}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="mb-3 col-12">
                    <label className="form-label fw-semibold">Type <span style={{color:'red'}}>*</span></label>
                    <select 
                      className="form-select" 
                      value={sharePointPhaseType}
                      onChange={(e) => {
                        setSharePointPhaseType(e.target.value);
                        if (e.target.value === 'non-phase') {
                          setSharePointNetwork('');
                        }
                      }}
                    >
                      <option value="phase">Phase</option>
                      <option value="non-phase">Non Phase</option>
                    </select>
                  </div>
                  
                  {sharePointPhaseType === 'phase' && (
                    <>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Phase Number <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointPhaseNumber}
                          onChange={(e) => {
                            setSharePointPhaseNumber(e.target.value);
                          }}
                        >
                          <option value="15">Phase 15 (2025)</option>
                          <option value="16">Phase 16 (2026)</option>
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Area <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointNetwork}
                          onChange={(e) => {
                            setSharePointNetwork(e.target.value);
                          }}
                        >
                          <option value="">Select Area</option>
                          <option value="EPN">EPN</option>
                          <option value="LPN">LPN</option>
                          <option value="SPN">SPN</option>
                        </select>
                      </div>
                    </>
                  )}
                  
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={()=>{
                    setShowSharePointUploadModal(false);
                    setSharePointUploadRecord(null);
                    setSharePointPhaseType('phase');
                    setSharePointPhaseNumber('15');
                    setSharePointNetwork('');
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn" 
                  style={{background:'#8b1634', color:'#fff', fontWeight:600}}
                  onClick={handleSharePointUpload}
                >
                  Upload to SharePoint
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AdminTaylorImportModal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        title="Upload PPM Report File"
        importPath="ppm-report/import-form"
        isAdminUser={isAdminUser}
        onImported={({ insertedRow }) => {
          if (insertedRow && insertedRow._id) {
            setRecords((prev) => [insertedRow, ...prev]);
            setPage(1);
          }
        }}
      />

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'1200px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Delete PPM Report</h5>
                <button type="button" className="btn-close" onClick={()=>setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default PPMReportPage;
